import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-16 mx-6 lg:mx-12 rounded-3xl mb-8">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <h3 className="text-4xl font-light mb-4">掌握最新資訊</h3>
            <p className="text-teal-100 text-sm mb-8 leading-relaxed">
              追蹤官方IG，最新資訊不漏接
            </p>
            <div className="flex justify-center items-center bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-64 h-64">
                <img
                  src="https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/0421a547332b71fa546e97dacd46a848.jpeg"
                  alt="Instagram QR Code"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-medium mb-6 text-teal-100">快速連結</h4>
            <ul className="space-y-4">
              <li>
                <button onClick={() => scrollToSection('plans')} className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
                  門號方案
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
                  手機專區
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
                  配件商城
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('consultation')} className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
                  常見問題
                </button>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-medium mb-6 text-teal-100">聯絡我們</h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm text-teal-100 mb-1">電話</p>
                <p className="text-lg">0984-506-588</p>
              </div>
              <div>
                <p className="text-sm text-teal-100 mb-1">Email</p>
                <p>wantbuymobile@gmail.com</p>
              </div>
              <div>
                <p className="text-sm text-teal-100 mb-1">LINE ID</p>
                <p>0984506588</p>
              </div>
              <div className="pt-2">
                <p className="text-sm font-medium mb-2 text-teal-100">門市地址</p>
                <p className="leading-relaxed">
                  彰化縣員林市三民東街70號
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex space-x-8">
            <a href="https://www.facebook.com/profile.php?id=61568503476409" target="_blank" rel="noopener noreferrer" className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
              Facebook
            </a>
            <a href="https://www.instagram.com/accounts/onetap/?next=%2F" target="_blank" rel="noopener noreferrer" className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
              Instagram
            </a>
            <a href="https://page.line.me/497ghssl" target="_blank" rel="noopener noreferrer" className="hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
              LINE
            </a>
          </div>

          <p className="text-sm text-teal-100">
            © 2025 通訊行. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
          </p>

          <div className="flex space-x-6">
            <a href="#privacy" className="text-sm hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
              隱私權政策
            </a>
            <a href="#terms" className="text-sm hover:text-teal-100 transition-colors border-b border-transparent hover:border-teal-100 cursor-pointer">
              服務條款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
